module.exports = __webpack_public_path__ + "static/img/kefu_logo.b3e1ddc.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home/kefu_logo.gif
// module id = sgNu
// module chunks = 11